var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1361d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df2910"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdc42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "37.059048%",
    x2: "62.940952%",
    xlinkHref: "#d",
    y1: "1.703709%",
    y2: "98.296291%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    xlinkHref: "#d",
    y1: "0%",
    y2: "100%"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.71764533 3.41559079-.47955009.29185713.01298064-.56123114-.29185714-.47955011.56123115.01298064.47955011-.29185714-.01298065.56123115.29185715.47955011zm-1.40845338-1.54938354-.55339658-.0943458.37799738-.41505046.0943458-.55339657.41505046.37799737.55339657.09434581-.37799737.41505045-.09434581.55339658zm.27837822 4.9742898-.46907231.3084154-.00661396-.56134228-.3084154-.46907231.56134228-.00661396.46907231-.3084154.00661396.56134228.3084154.46907231zm.96532576-1.51295124-.55796415.06184576.24895098-.50316231-.06184576-.55796415.50316231.24895098.55796412-.06184576-.24895093.50316231.06184571.55796415z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 4.70095242-1.34350915.95775309.49571016-1.57371511-1.32604448-.98179115 1.64987488-.01485633.52396859-1.5645334.52396859 1.5645334 1.64987488.01485633-1.32604448.98179115.49571016 1.57371511z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.9166e86b515c30a76865428b55ed59cd.svg";
export { ForwardRef as ReactComponent };